import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,useMapEvents,

  ZoomControl
} from "react-leaflet";
import Zoomin from "../../assets/img/map/search-zoom-in.svg";
import Zoomout from "../../assets/img/map/search-zoom-out.svg";
import marker from "../../assets/img/map/marker.svg";
import L from "leaflet";
import MapSearch from "./MapSearch";
import { OpenStreetMapProvider, GeoSearchControl } from "leaflet-geosearch";
import * as ELG from "esri-leaflet-geocoder";
import { useCreatePlace } from "../../context/CreatePlaceContext";

const Map = ({markerPos,setMarkerPos}) => {
  const newIcon = L.icon({
    iconUrl: marker,
    iconSize: [52, 90],
    iconAnchor: [40, 41]
  });
  const { updatePlaceDetail, createInfoData } = useCreatePlace();

  // function Geocoder({ address }) {
  //   const map = useMap();

  //   ELG.geocode()
  //     .text(address)
  //     .run((err, results, response) => {
  //       console.log(results.results[0].latlng);
  //       const { lat, lng } = results.results[0].latlng;
  //       map.setView([lat, lng], 12);
  //     });

  //   return null;
  // }
  //https://nominatim.openstreetmap.org/search.php?q=%D8%AA%D9%87%D8%B1%D8%A7%D9%86&polygon_geojson=1&format=jsonv2
  const encodedAddress = encodeURIComponent(createInfoData.stepThree.city[0].title);
console.log("title",createInfoData.stepThree.city[0].title)
  const nominatimURL =
    "https://nominatim.openstreetmap.org/search.php?q=" +
    encodedAddress +
    "&polygon_geojson=1&format=jsonv2";
  const [loc, setloc] = useState(null);

  useEffect(() => {
   if(createInfoData.stepFour.lat === null ){ fetch(nominatimURL).then(response => response.json()).then(data => {
      const lat = data[0].lat;
      const long = data[0].lon;
      setloc([data[0].lat, data[0].lon]);
       setMarkerPos({
         lat: lat,
         lng: long,
       })
    });}else{
      setMarkerPos({
        lat:createInfoData.stepFour.lat,
        lng:createInfoData.stepFour.lng
      })
    }
  }, []);
  const markerRef = useRef();

  const updatePosition = () => {
    const marker = markerRef.current;
    if (marker != null) {
      const newPos = { ...marker.leafletElement.getLatLng() };
      setMarkerPos(newPos);
    }
  };
  const handleMapClick = (e) => {
    const { lat, lng } = e.latlng;
    setMarkerPos({lat:lat, lng:lng}); // Update marker position
  };

  // Component that listens for map click events
  const MapClickHandler = () => {
    useMapEvents({
      click: handleMapClick,
    });
    return null;
  };
 

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          setMarkerPos(marker.getLatLng());
          //setloc(markerPos.lat, markerPos.lng);
          console.log("Marker",markerPos)

        }
      }
    }),
    []
  );
  console.log("markerPos",markerPos)
  return (
    <div className="Map">
      {markerPos &&
        <MapContainer center={markerPos} zoom={13}>
          <TileLayer
            attribution="&copy; <a href=&quot;http://www.openstreetmap.org/copyright&quot;>OpenStreetMap</a> &copy; <a href=&quot;http://cartodb.com/attributions&quot;>CartoDB</a>"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
      <MapClickHandler />
          <Marker
            onDragend={updatePosition}
            eventHandlers={eventHandlers}
            ref={markerRef}
            draggable={true}
            icon={newIcon}
            position={markerPos}
          />
          <ZoomControl
            position="bottomright"
            zoomInText={`<img src=${Zoomin} />`}
            zoomOutText={`<img src=${Zoomout} />`}
          />
          {/* <Geocoder address="اصفهان" /> */}
          {/* <MapSearch provider={new OpenStreetMapProvider()} /> */}
        </MapContainer>}
    </div>
  );
};

export default Map;
